import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { RequestCounter } from '@app-core/store/models/request-counter.model';
import { ChipFilterList } from '@app-models/list-chip-filter';

@Component({
  selector: 'app-request-filter',
  templateUrl: './request-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestFilterComponent implements OnChanges {
  @Input() counters: RequestCounter;
  @Input() selectedFilter: string;
  @Input() filter: string;
  @Input() showmore = true;
  @Input() showicon = true;
  @Input() habilitarcheck = true;

  @Output() output = new EventEmitter<any>();

  filters: ChipFilterList[] = [
    {
      iconName: 'schedule',
      text: 'Pending Review',
      state: 'pending',
      filter: '1',
      value: 0,
    },
    {
      iconName: 'back_hand',
      text: 'Approved by Manager',
      state: 'aprovedbym',
      filter: '5',
      value: 0,
    },
    {
      iconName: 'check_circle',
      text: 'Approved by HR',
      state: 'aprovedbyHR',
      filter: '47',
      value: 0,
    },
    {
      iconName: 'done',
      text: 'Done',
      state: 'done',
      filter: '3',
      value: 0,
    },
    {
      iconName: 'close',
      text: 'Rejected',
      state: 'rejected',
      filter: '46',
      value: 0,
    },
    {
      iconName: 'cancel',
      text: 'cancelled',
      state: 'cancelled',
      filter: '11',
      value: 0,
    },
  ];

  ngOnChanges(changes): void {
    if (changes && changes.counters) {
      this.setFiltersValues(changes.counters.currentValue);
    }
    if (changes && changes.selectedFilter) {
      this.selectedFilter = changes.selectedFilter.currentValue;
    }
    if (changes && changes.filter) {
      this.filter = changes.filter.currentValue;
    }
  }

  setFiltersValues(counters: RequestCounter) {
    if (counters) {
      this.filters = [
        {
          iconName: 'schedule',
          text: 'Pending Review',
          state: 'pending',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
        {
          iconName: 'back_hand',
          text: 'Approved by Manager',
          state: 'aprovedbym',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
        {
          iconName: 'check_circle',
          text: 'Approved by HR',
          state: 'aprovedbyHR',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
        {
          iconName: 'done',
          text: 'Done',
          state: 'done',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
        {
          iconName: 'close',
          text: 'Rejected',
          state: 'rejected',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
        {
          iconName: 'cancel',
          text: 'cancelled',
          state: 'cancelled',
          filter: counters.pendingid.toString(),
          value: counters.pending,
        },
      ];
    }
  }

  outputData($event) {
    this.output.emit($event);
  }
}
